export const getFavoritesProducts = (payload: number) => ({
  type: "@saga/GET_FAVORITES_PRODUCTS",
  payload,
});
